import { render, staticRenderFns } from "./Aplicativos.vue?vue&type=template&id=3764b07e&scoped=true"
import script from "./Aplicativos.vue?vue&type=script&lang=js"
export * from "./Aplicativos.vue?vue&type=script&lang=js"
import style0 from "./Aplicativos.vue?vue&type=style&index=0&id=3764b07e&prod&lang=css"
import style1 from "./Aplicativos.vue?vue&type=style&index=1&id=3764b07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764b07e",
  null
  
)

export default component.exports